import "./Users.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import {
  DeleteOutlined,
  FormOutlined,
  LockOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  PageSetting,
  Query,
  RoleType,
  RoleTypeMap,
  User,
  UsersMessages,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import {
  find,
  search,
} from "../../../../controllers/store/actions/users/get-users-actions";
import { findById } from "../../../../controllers/store/actions/users/update-users-actions";
import { remove } from "../../../../controllers/store/actions/users/delete-user-action";
import { clear } from "../../../../controllers/store/actions/users/create-user-action";
import NewUserModal from "../../../components/Forms/Modal/Users/NewUser";
import UpdateUserModal from "../../../components/Forms/Modal/Users/UpdateUser";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Users: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [api, contextHolder] = notification.useNotification();
  const usersState = useSelector((state: any) => state.users);
  const updatedUserState = useSelector((state: any) => state.updatedUser);
  const deletedUserState = useSelector((state: any) => state.deletedUser);
  const createdUserState = useSelector((state: any) => state.createdUser);

  const columns: TableProps<User>["columns"] = [
    {
      title: "Nombres",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Apellidos",
      dataIndex: "last_name",
      key: "last_name",
    },
    {
      title: "Tipo",
      dataIndex: "role",
      key: "role",
      render: (text) => {
        console.log("text", text);
        return (
          <Button
            icon={<LockOutlined />}
            size="small"
            type={text === RoleType.Root ? "primary" : "default"}
          >
            {RoleTypeMap[text as keyof typeof RoleTypeMap]}
          </Button>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Telefono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Departamento",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Ciudad",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: any) => (
        <Space size="middle">
          <Button
            disabled={record?.role === RoleType.Root}
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            disabled={record?.role === RoleType.Root}
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: UsersMessages.Title,
                content: UsersMessages.userConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      dispatch(search(1, pageSize, value));
    } else {
      dispatch(find(1, pageSize, query));
    }
  };

  useEffect(() => {
    dispatch(find(1, pageSize, query));
  }, [pageSize]);

  return (
    <Layout className="users-layout">
      {contextHolder}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="users-content">
        <Card className="users-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            <h1 className="heading-content-title">
              Usuarios
              <span className="heading-content-subtitle">
                Listado de usuario
              </span>
            </h1>
            <br />
          </Col>
          <NewUserModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => setVisibleCreateModal(false)}
          />
          <UpdateUserModal
            user={updatedUserState.user}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => setVisibleUpdateModal(false)}
          />
          <Row gutter={[8, 8]} style={{ marginBottom: 20 }}>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Search
                value={searchTerm}
                placeholder="Buscar"
                allowClear
                onChange={(e) => setSearchTerm(e.target.value)}
                onSearch={handleSearch}
                enterButton
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={12} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                icon={<PlusOutlined />}
              >
                Agregar usuario
              </Button>
            </Col>
          </Row>
          <Skeleton loading={usersState.isLoading} active>
            {usersState?.list?.length ? (
              <Table
                pagination={{
                  total:
                    usersState.meta?.total_count ||
                    usersState.meta?.filter_count,
                  current: page,
                  pageSize,
                  onChange: (newPage) => {
                    setPage(newPage);
                    dispatch(find(newPage, pageSize, query));
                  },
                }}
                columns={columns}
                dataSource={usersState.list}
              />
            ) : (
              <Empty description="No tienes usuarios aún">
                <Button
                  type="primary"
                  onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                >
                  Agregar usuario
                </Button>
              </Empty>
            )}
          </Skeleton>
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Users;
